import styled from 'styled-components';
import type {RecentActivityPreview_activity$key} from './__generated__/RecentActivityPreview_activity.graphql';
import type {AiSummaryBlock_ticket$key} from './__generated__/AiSummaryBlock_ticket.graphql';
import {AiSummaryBlock} from './AiSummaryBlock';
import {AiSuggestedActionsList} from './AiSuggestedActionsList';
import {TicketDescription} from './TicketDescription';
import {RecentActivityPreview} from './RecentActivityPreview';
import {ReplyComposer} from './ReplyComposer';

const Divider = styled.div`
	border-top: 1px solid #e2e8f0;
`;

interface Props {
	ticketRef: AiSummaryBlock_ticket$key;
	description: string | null;
	timeline: readonly RecentActivityPreview_activity$key[];
	ticketId: string;
	requesterEmail: string;
	onRefetch: () => void;
	onNavigateToActivity: () => void;
}

export function OverviewTab({
	ticketRef,
	description,
	timeline,
	ticketId,
	requesterEmail,
	onRefetch,
	onNavigateToActivity,
}: Props) {
	return (
		<>
			<AiSummaryBlock ticketRef={ticketRef} />
			<AiSuggestedActionsList ticketRef={ticketRef} />
			<TicketDescription description={description} />
			<Divider data-testid="overview-divider" />
			<RecentActivityPreview entries={timeline} onViewAll={onNavigateToActivity} />
			<ReplyComposer ticketId={ticketId} requesterEmail={requesterEmail} onSent={onRefetch} />
		</>
	);
}
